export const getCategoryTitle = (category: string) => {
  switch (category) {
    case 'MODUL_AJAR':
      return 'Kegiatan Intrakurikuler'
    case 'BAHAN_AJAR':
      return 'Bahan Ajar'
    case 'MODUL_PROJEK':
      return 'Kegiatan Kokurikuler'
    default:
      return category
  }
}
